import {Injectable, signal} from '@angular/core';
import {WizardStepData, WizardValidation} from './wizard.model';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export abstract class WizardService<T> {
  private readonly stepDataMap = new Map<number, any>();
  private readonly stepValidityMap = new Map<number, boolean>();
  private readonly formDataSignal = signal<Partial<T>>({});

  private readonly stepValidityChange = new BehaviorSubject<WizardValidation | null>(null);
  readonly stepValidityChange$ = this.stepValidityChange.asObservable();

  isEdit = signal<boolean>(false);

  protected updateFormData(data: Partial<T>): void {
    this.formDataSignal.set({...this.formDataSignal(), ...data});
  }

  getStepValidityMap(): Map<number, boolean> {
    return this.stepValidityMap;
  }

  clearFormData(): void {
    this.formDataSignal.set({});

    this.stepDataMap.clear();
    this.stepValidityMap.clear();
    this.stepValidityChange.next(null);
  }

  updateStepData<S>(stepData: WizardStepData<S>): void {
    this.stepDataMap.set(stepData.stepIndex, stepData.data);
    this.buildPartialDTO();
  }

  updateStepValidity(validation: WizardValidation): void {
    this.stepValidityMap.set(validation.stepIndex, validation.isValid);
    this.stepValidityChange.next(validation);
  }

  getStepData<S>(stepIndex: number): S | undefined {
    return this.stepDataMap.get(stepIndex);
  }

  get formData(): Partial<T> {
    return this.formDataSignal();
  }

  protected abstract buildPartialDTO(): void;

  abstract buildFinalRequest(): T;
}
